module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Bold.704b3917.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Bold.woff
// module id = 519
// module chunks = 0